import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { CSP_NONCE, isDevMode } from "@angular/core";

function bootstrap() {
  if (!isDevMode()) {
    window.console.log = () => {};
  }

  platformBrowserDynamic()
    .bootstrapModule(AppModule,{
       providers: [{
    provide: CSP_NONCE,
    useValue:generateRandomNonce()
  }]
    })
    .catch((err) => console.error(err));
}

     function generateRandomNonce(): string {
          // Implement your random nonce generation here.
          // For example, using Crypto API:
          const array = new Uint8Array(16);
          window.crypto.getRandomValues(array);
          return btoa(String.fromCharCode.apply(null, Array.from(array)));
        }
if (document.readyState === "complete") {
  bootstrap();
} else {
  document.addEventListener("DOMContentLoaded", bootstrap);
}
